module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Git#1-445c058a31eeeff95b92821c3cd745adfb426486c9ca1512e1366fb8b0e9a303.svg";